// extracted by mini-css-extract-plugin
module.exports = {"merchantContent":"content_merchantContent__1Ve05"};